import {EventEmitter, Injectable} from '@angular/core';
import {FieldValidationService} from './FieldValidationService';

@Injectable()
export class FieldService {

  public OnFieldAddOrRemoved: EventEmitter<any> = new EventEmitter<any>()
  public OnFieldChanged: EventEmitter<any> = new EventEmitter<any>()

  fields = [
    {
      name: 'textfield',
      value: 'Textfield'
    },
    {
      name: 'email',
      value: 'E-mail'
    },
    {
      name: 'radio',
      value: 'Radio Buttons'
    },
    {
      name: 'dropdown',
      value: 'Dropdown List'
    },
    {
      name: 'textarea',
      value: 'Text Area'
    },
    {
      name: 'checkbox',
      value: 'Checkbox'
    },
    {
      name: 'note',
      value: 'Title'
    },
    {
      name: 'scale',
      value: 'Scale'
    },
    {
      name: 'user_information',
      value: 'Employee Information'
    },
    {
      name: 'date',
      value: 'Date'
    },
    {
      name: 'time',
      value: 'Time'
    },
    {
      name: 'branches',
      value: 'Branches'
    },
    {
      name: 'employees',
      value: 'Employee Picker'
    },
    {
      name: 'file',
      value: 'File'
    },
    {
      name: 'richText',
      value: 'Rich Text'
    },
    {
      name: 'signature',
      value: 'Signature'
    },
    {
      name: 'calculated_field',
      value: 'Calculated Field'
    },
    {
      name: 'multiple_selection',
      value: 'Multiple Selection'
    },
    {
      name: 'duplicate_block',
      value: 'Duplicate'
    },
    {
      name: 'branch_information',
      value: 'Branch Information'
    },

    {
      name: 'selected_employee_information',
      value: 'Selected Employee Information'
    }
  ]

  public form_fields: any[] = [];

  public AddField = {
    new: null,
    types: [],
    lastAddedID: 0
  }

  constructor(private validator: FieldValidationService) {
  }

  GetMaxFieldId() {
    let fieldId = 0
    let maxId = 0;
    if (this.form_fields && this.form_fields.length > 0) {

      this.form_fields.forEach((field: any) => {
        const t = parseInt(field.field_id);
        if (maxId < t) {
          maxId = t;
        }
      });
      fieldId = maxId + 1;
    }

    return fieldId;
  }

  GetField(fieldType: string, fieldId: number)  {

    let newField: {};
    switch (fieldType) {
      case 'textfield':
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": '',
          "field_required": false,
          "field_disabled": false,
          "input_type": "text",
          "layout": "vertical",
          "labelWidth": 70
        };
        break;
      case  'scale':
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": 0,
          "field_required": false,
          "field_disabled": false,
          "max_scale_value": 10,
          "min_scale_value": 0,
          'temperature_format': 'F'
        };
        break;
      case  'user_information':
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": '',
          "field_required": false,
          "field_disabled": false,
          "source_field": [],
          "part_of_system": ''
        };
        break;
      case  'branch_information':
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": "",
          "field_type": fieldType,
          "field_value": '',
          "field_required": false,
          "field_disabled": false,
          "source_field": []
        };
        break;
      case  'file':
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": '',
          "field_required": false,
          "field_disabled": false,
          "multiple_upload": true
        };
        break;
      case 'richText':
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": '',
          "field_required": false,
          "field_disabled": false,
          "multiple_upload": true
        };
        break;
      case 'calculated_field':
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": "",
          "operation": "",
          "percent_sign": "",
          "selected_fields": [],
          "field_required": false,
          "field_disabled": false,
          "order": [],
          "use_as_subtotal": false,
          "showError": "",
          "open_formula_formula": "",
          "allowedPlaceholders": []
        };
        break;
      case "employees":
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": "",
          "field_required": false,
          "field_disabled": false,
          "positions_filter": "",
          "add_as_approver": "",
          "employee_id": ""
        };
        break;

      case "duplicate_block":
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": "",
          "field_required": false,
          "field_disabled": false,
          "order": []
        };
        break;
      case "radio":
      case "dropdown":
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": "",
          "field_required": false,
          "field_disabled": false,
          "calculate_by_additional_val": false,
          "layout": "vertical",
          "labelWidth": 70
        };
        break;
      case "signature":
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": "",
          "required_employee_signature": false,
          "required_employee_id": '',
          "required_employee_name": '',
          "related_employee_picker_id": '',
          "field_required": false,
          "field_disabled": false
        };
        break;
      case "branches":
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": "",
          "field_required": false,
          "field_disabled": false,
          "enable_manual_input": false
        };
        break;
      default :
        newField = {
          "isOpen": true,
          "field_id": fieldId,
          "field_hint": "",
          "field_title": '',
          "field_type": fieldType,
          "field_value": "",
          "field_required": false,
          "field_disabled": false
        };
        break;
    }

    return newField;

  }

  AddNewField()  {
    const fieldId = this.GetMaxFieldId();
    const newField = this.GetField(this.AddField.new, fieldId);

    this.form_fields.push(newField);

    this.OnFieldAddOrRemoved.emit(newField)
  }

  Duplicate(startField: any) {
    if (typeof startField == "undefined" || typeof startField.field_id == "undefined") {
      return false;
    }

    const fieldId = this.GetMaxFieldId()
    let templateField = this.GetField(startField.field_type, fieldId);
    let fieldResult = Object.assign(templateField, startField);
    fieldResult.field_id = fieldId;
    delete fieldResult.$$hashKey;

    if (typeof fieldResult.field_options != "undefined") {

      fieldResult.field_options = [];

      if (Array.isArray(fieldResult.field_options) && fieldResult.field_options.length > 0) {
        startField.field_options.forEach((option: any) => {
          const option1: any = {...option};
          option1.option_value = parseInt(option1.option_id) + 1;
          delete option1.$$hashKey;
          fieldResult.field_options.push(option1)
        })
      }
    }

    if (typeof fieldResult.order != "undefined" && Array.isArray(fieldResult.order)) {
      fieldResult.order = [...startField.order];
    }

    this.OnFieldAddOrRemoved.emit(fieldResult)
    return fieldResult;
  }

  ShowAddOptions(field: any) {
    if (field.field_type == "radio"
      || field.field_type == "dropdown"
      || field.field_type == "checkbox"
      || field.field_type == "multiple_selection"
    ) {
      this.PredefinedOptions(field);
      return true;
    }
    return false;
  }

  PredefinedOptions(field: any) {
    if (!field.field_options) {

      field.field_options = [];
      let defaultPredefinedCount = 2;

      if (field.field_type == "checkbox") {
        field.field_value = [];
        defaultPredefinedCount = 1;
      }

      for (let i = 0; i < defaultPredefinedCount; i++) {
        const counter = i + 1;
        let newOption;
        switch (field.field_type) {

          case "checkbox" :
            newOption = {
              "option_id": i,
              "option_title": '',
              "option_value": counter,
              "predefined": true,
              "isChecked": false
            };
            field.field_options.push(newOption);
            break;

          case "dropdown":
          case "radio":
            newOption = {
              "option_id": i,
              "option_title": '',
              "option_value": counter,
              "option_additional_value": 0
            };
            field.field_options.push(newOption);
            break;
          default :
            newOption = {
              "option_id": i,
              "option_title": '',
              "option_value": counter,
              "predefined": true
            };
            field.field_options.push(newOption);
            break;
        }
      }
    }
  }

  AddOption(field: any) {
    let lastOptionID = 0;

    if (!field.field_options) {
      field.field_options = [];
    }

    if (field.field_options[field.field_options.length - 1]) {
      lastOptionID = field.field_options[field.field_options.length - 1].option_id;
    }

    const countOptions = field.field_options.length;

    // new option's id
    const optionId = (countOptions > 0) ? lastOptionID + 1 : 0;
    const counter = optionId + 1;
    let newOption;

    switch (field.field_type) {

      case "checkbox" :

        if (!field.field_value) {
          field.field_value = [];
        }

        newOption = {
          "option_id": optionId,
          "option_title": '',
          "option_value": counter,
          "isChecked": false
        };
        field.field_options.push(newOption);
        field.field_value.push(newOption);

        break;
      case "dropdown":
      case "radio":
        newOption = {
          "option_id": optionId,
          "option_title": '',
          "option_value": counter,
          "option_additional_value": 0
        };
        field.field_options.push(newOption);
        break;

      default :
        newOption = {
          "option_id": optionId,
          "option_title": '',
          "option_value": counter
        };
        field.field_options.push(newOption);
        break;
    }

    this.OnFieldChanged.emit(field)
  }

  DeleteOption(field: any, option: any) {
    for (let i = 0; i < field.field_options.length; i++) {
      if (field.field_options[i].option_id == option.option_id) {
        field.field_options.splice(i, 1);
        break;
      }
    }

    const optionLenght = field.field_options.length;

    for (let i = 0; i < optionLenght; i++) {
      if (typeof field.field_options[i] != "undefined") {
        field.field_options[i].option_id = i;
        field.field_options[i].option_value = (i + 1);
      }
    }
    this.OnFieldChanged.emit(field)
  }

  SetFields(form_fields: any[]) {
    this.form_fields = form_fields;
    this.form_fields.forEach((field: any) => {

      // Set layout and labelWidth for textfield if missing
      if(field.field_type == "textfield") {
        field.layout = field.layout ? field.layout : "vertical";
        field.labelWidth = field.labelWidth ? field.labelWidth : 70;

        // Fix for 1269
        // Fix for textfield->number field value - should be a number
        if(field.input_type === "number" && typeof field.field_value === "string" && field.field_value) {
          const v = parseFloat(field.field_value);
          if(isNaN(v)) {
            field.field_value = v;
          }
        }

      }


    })
    this.validator.SetFields(this.form_fields);
  }

  DeleteField(fieldId: any)  {
    const field = this.form_fields.find((field: any) => field.field_id == fieldId);
    if (field) {
      const index = this.form_fields.indexOf(field);
      this.form_fields.splice(index, 1);
    }
    this.OnFieldAddOrRemoved.emit(field)
  }

  Validate(): boolean {
    return this.validator.Validate();
  }

  GetValidationErrors(): string[] {
    console.log(this.validator.errors);
    return this.validator.errors;
  }

  Init() {
    this.AddField.types = this.fields;
    this.AddField.new = this.AddField.types[0].name;
    this.AddField.lastAddedID = 0;
  }
}
